// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A5F6).
// The Danger zone (A12U11, D183): the owner only (org.delete); transfer and delete ask again for the password through
// the shared ReauthSheet (withReauth, D74), and beside them what deleting does.
import { ids } from '@orca/api-client/testIds'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { DangerInfo } from '../../../../features/organization/DangerInfo'
import { OrgSection } from '../../../../features/organization/OrgSection'
import { DangerZone } from '../../../../features/settings/DangerZone'
import { orgQuery } from '../../../../features/settings/queries'
import '../../../../features/settings/strings'
import { accessQuery } from '../../../../shared/access/access'
import { meQuery } from '../../../../shared/org/me'

export const Route = createFileRoute('/o/$orgSlug/organization/danger')({
  staticData: { screenId: 'OrgDangerZoneScreen', access: 'owner', ownHeader: true },
  loader: async ({ context: { queryClient, membership } }) => {
    await Promise.all([
      queryClient.ensureQueryData(orgQuery(membership.orgId)),
      queryClient.ensureQueryData(accessQuery(membership.orgId)),
    ])
    return { orgId: membership.orgId }
  },
  component: OrgDangerZoneScreen,
})

function OrgDangerZoneScreen() {
  const { t } = useTranslation()
  const { orgId } = Route.useLoaderData()
  // Only the owner opens it, so the person reading is the owner.
  const { data: me } = useQuery(meQuery())
  return (
    <OrgSection
      orgId={orgId}
      section="danger"
      root={ids.orgDangerZone.root}
      title={t('settings.danger.title')}
      subtitle={t('organization.danger.subtitle', { name: me?.user?.displayName ?? '' })}
    >
      <div className="grid gap-(--stack-lg) expanded:grid-cols-2">
        <Suspense fallback={null}>
          <DangerZone orgId={orgId} />
        </Suspense>
        <Suspense fallback={null}>
          <DangerInfo orgId={orgId} />
        </Suspense>
      </div>
    </OrgSection>
  )
}
